import { render, staticRenderFns } from "./website_youtube_link.vue?vue&type=template&id=63ae648f&scoped=true"
import script from "./website_youtube_link.vue?vue&type=script&lang=js"
export * from "./website_youtube_link.vue?vue&type=script&lang=js"
import style0 from "./website_youtube_link.vue?vue&type=style&index=0&id=63ae648f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae648f",
  null
  
)

export default component.exports